import React from "react";
import "./InlineLoader.css";

const InlineLoader = ({ 
  text = "Loading...", 
  containerClassName = "",
  spinnerClassName = "",
  textClassName = ""
}) => {
  return (
    <div className={`inline-loader-container ${containerClassName}`}>
      <div className={`inline-loader-spinner ${spinnerClassName}`}></div>
      <p className={`inline-loader-text ${textClassName}`}>{text}</p>
    </div>
  );
};

export default InlineLoader; 